module.exports = __webpack_public_path__ + "static/media/mazaZoleWon_100_250.bc452aca.png";